<template>
  <div class="h-2 w-2 rounded-full bg-pink-300" />
</template>
